import { useEffect } from 'react';
import { useAppSettings } from './useGlobalSettings';

/**
 * Hook to update document title based on global settings
 */
export const useDocumentTitle = (customTitle: string | null = null) => {
  const { appName, loading } = useAppSettings();

  useEffect(() => {
    if (!loading) {
      const title = customTitle ? `${customTitle} - ${appName}` : appName;
      document.title = title;
    }
  }, [appName, customTitle, loading]);

  return { appName, loading };
};

export default useDocumentTitle; 